import { ref } from 'vue';
import { useStore } from "./store.service";
const store = useStore();

export function setTitle(newTitle: string | null = null) {
  const baseTitle = store.readConfig<string>('SITE_NAME') || document.title;

  const titleRef = ref<string>(baseTitle);
  document.title = baseTitle;

  const fullTitle = (newTitle !== null && newTitle?.trim() !== '')
    ? `${newTitle?.trim()} - ${baseTitle}`
    : baseTitle;

  titleRef.value = fullTitle;
  document.title = fullTitle;

  return fullTitle;
}
